import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './ProfileSuggestionModal.scss';
import { putRequest, deleteRequest } from '../../requestUtils';

class ProfileSuggestionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: props.forceShow,
      isHovering: false,
    };
    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleDecline = this.handleDecline.bind(this);
    this.handleAccept = this.handleAccept.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleMouseOver() {
    this.setState({ isHovering: true });
  }

  handleMouseLeave() {
    this.setState({ isHovering: false });
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleAccept() {
    const {
      csrfToken,
      appendTags,
      tags,
    } = this.props;

    return putRequest(
      '/profile_suggestions',
      {
        profile_suggestion_ids: tags.map((tag) => tag.id),
      },
      csrfToken,
    ).then(() => {
      appendTags(
        tags.map((tag) => ({
          image: null,
          label: tag.label,
          value: tag.taggable_id,
        })),
      );
    });
  }

  handleDecline() {
    const { csrfToken, clearTags, tags } = this.props;

    const tagIds = tags.map((tag) => tag.id);
    return deleteRequest(
      `/profile_suggestions/?profile_suggestion_ids=[${tagIds}]`,
      csrfToken,
    ).then(() => {
      clearTags(tagIds);
    });
  }

  handleRemove(e) {
    e.preventDefault();
    const { csrfToken, clearTags } = this.props;
    const tagId = Number(e.target.dataset.id);
    deleteRequest(
      `/profile_suggestions/?profile_suggestion_ids=[${tagId}]`,
      csrfToken,
    ).then(() => {
      clearTags([tagId]);
    });
  }

  renderModalButton() {
    const { showEdit, editMode, tags } = this.props;
    const { isHovering } = this.state;

    if (tags.length === 0) return null;

    return (
      <span
        className="profile-suggestion-modal-button"
        onMouseOver={this.handleMouseOver}
        onMouseLeave={this.handleMouseLeave}
      >
        <a
          role="button"
          tabIndex={0}
          onClick={this.handleShowModal}
        >
          <i className="fas fa-magic wand" />
          &nbsp;
          <span className="blue-circle">{tags.length}</span>
          {showEdit && (isHovering || editMode) && <span>&nbsp;&nbsp;Edit</span>}
        </a>
      </span>
    );
  }

  renderModal() {
    const { tags } = this.props;

    return (
      <Modal
        show={this.state.showModal}
        onHide={this.handleHideModal}
        dialogClassName="profile-suggestion-modal"
      >
        <Modal.Header closeButton />
        <Modal.Body className="profile-suggestion-card">
          <div className="cta row">
            <div className="col-md-10 col-xs-8">
              <div className="cta-text mb-2">
                Suggestions for
                {' '}
                {(tags.length && tags[0].title) || 'N/A'}
              </div>
            </div>
            <div className="col-md-1 col-xs-2">
              <i className="fas fa-magic wand" />
&nbsp;&nbsp;
              <span className="blue-circle">{tags.length}</span>
            </div>
          </div>
          <div className="cta row">
            <div className="col-md-12">
              <div className="body-text-2">
                Level up your profile by accepting Clora recommendations.
              </div>
            </div>
          </div>
          <div className="row profile-suggestion-color">
            <div className="tags mb-2 mt-15">
              {tags.map((t) => (
                <span key={t.label} className="badge small normal-font mr-5">
                  {t.label}
&nbsp;&nbsp;
                  <i
                    role="button"
                    data-id={t.id}
                    onClick={this.handleRemove}
                    className="fas fa-times"
                    tabIndex={0}
                  />
                </span>
              ))}
            </div>
          </div>
          <br />
          <div className="row button-row profile-suggestion-color">
            <div
              className="suggestion-button decline-button col-md-6 col-xs-6"
              onClick={this.handleDecline}
              role="button"
              tabIndex={0}
            >
              Decline Suggestions
            </div>
            <div
              className="suggestion-button accept-button col-md-6 col-xs-6"
              onClick={this.handleAccept}
              role="button"
              tabIndex={0}
            >
              Add Suggestions
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const { tags } = this.props;

    if (tags.length === 0) return null;
    return (
      <span>
        &nbsp;&nbsp;
        {this.renderModalButton()}
        {this.renderModal()}
      </span>
    );
  }
}

ProfileSuggestionModal.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  csrfToken: PropTypes.string,
  appendTags: PropTypes.func.isRequired,
  clearTags: PropTypes.func.isRequired,
  showEdit: PropTypes.bool,
  editMode: PropTypes.bool,
  forceShow: PropTypes.bool,
};

ProfileSuggestionModal.defaultProps = {
  csrfToken: '',
  showEdit: true,
  editMode: false,
  forceShow: false,
};

export default ProfileSuggestionModal;
